export const colNameMapping = {
  Type: "Type",
  FilePath: "Visual",
  DesignJobName: "Job Name",
  PMP: "PI PMP",
  RTA_POA: "POA (RTA)",
  Version: "Version",
  Markup: "Markup",
  Status: "Status",
  Approval: "Approval",
  EndDate: "End Date",
  BufferToWork: "B:W",
  DSBP_InitiativeID: "DSBP InitiativeID",
  DSBP_Initiative_Name: "DSBP Initiative Name",
  RTA_ProjectID: "RTA ProjectID",
  RTA_Project_Name: "RTA Project Name",
  PIMaterialNumber: "PIMaterialNumber",
  PIMaterialID: "PIMaterialID",
  PIMaterialDescription: "PIMaterialDescription",
  POANumber: "POA Number",
  POADescription: "POA Description",
  BufferToWorkRatio: "B|W",
  AWM_GroupPMP: "AWM GroupPMP",
  Design: "Design",
  RDTStatus: "RDTStatus",
  NPFStatus: "NPFStatus",
  IQStatus: "IQStatus",
  Copy: "Copy",
  RTA_RTAPOAStatus: "POA Status",
  TDState: "TDState",
  PMPState: "PMPState"
};